import React, { useContext, ElementType, ReactElement } from 'react';
import { useRoutes } from 'react-router';

import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import HeaderOnlyLayout from 'src/layouts/HeaderOnlyLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import { Web3AuthContext } from './contexts/Web3Auth';
const Loader = (Component: ElementType) => (props: object) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
const PageLoading = Loader(
  lazy(() => import('src/components/PageLoading/PageLoading'))
);

// public

const Login = Loader(lazy(() => import('src/pages/public/login/Login')));
const Register = Loader(
  lazy(() => import('src/pages/public/register/Register'))
);

const BadgeDetailPublic = Loader(
  lazy(() => import('src/pages/public/badge/BadgeDetailPublic'))
);
const IssuerPublicProfile = Loader(
  lazy(() => import('src/pages/public/badge/IssuerPublicProfile'))
);
const UserPublicProfile = Loader(
  lazy(() => import('src/pages/public/badge/UserPublicProfile'))
);

// dashboard
const MyBadges = Loader(
  lazy(() => import('src/pages/dashboard/badge/MyBadges'))
);

const Badges = Loader(lazy(() => import('src/pages/dashboard/badge/Badges')));
const BadgeDetailAsIssuer = Loader(
  lazy(() => import('src/pages/dashboard/badge/BadgeDetailAsIssuer'))
);
const BadgeDetailAsUser = Loader(
  lazy(() => import('src/pages/dashboard/badge/BadgeDetailAsUser'))
);
const CreateBadge = Loader(
  lazy(() => import('src/pages/dashboard/badge/CreateBadge'))
);
const IssueBadge = Loader(
  lazy(() => import('src/pages/dashboard/badge/IssueBadge'))
);
const Profile = Loader(
  lazy(() => import('src/pages/dashboard/account/Profile'))
);

export default function Router() {
  const { user, isLoading, isInitialized } = useContext(Web3AuthContext);
  const isLoggedIn = !!user;
  console.log('user', { user, isInitialized, isLoading, isLoggedIn });

  const routes = useRoutes([
    {
      path: '/',
      element: (
        <Navigate to={isLoggedIn ? '/dashboard/badges' : '/login'} replace />
      )
    },
    {
      path: '/login',
      element: isLoggedIn ? <Navigate to={'/dashboard/badges'} /> : <Login />
    },
    {
      path: '/register',
      element: isLoggedIn ? <Navigate to={'/dashboard/badges'} /> : <Register />
    },
    {
      path: '/',
      element: <HeaderOnlyLayout />,
      children: [
        {
          path: 'user/:userAddress',
          element: <UserPublicProfile />
        },
        {
          path: 'user/:userAddress/:issuerAddress/badge/:badgeTitle',
          element: <BadgeDetailPublic />
        },
        {
          path: 'issuer/:issuerAddress',
          element: <IssuerPublicProfile />
        },
        {
          path: 'issuer/:issuerAddress/badge/:badgeTitle',
          element: <BadgeDetailPublic />
        }
      ]
    },
    {
      path: '/dashboard',
      element: isLoggedIn ? (
        <SidebarLayout />
      ) : (
        <Navigate to={'/login'} replace />
      ),
      children: [
        { path: 'my-badges', element: <MyBadges /> },
        { path: 'badges', element: <Badges /> },
        { path: 'badges/:badgeTitle', element: <BadgeDetailAsIssuer /> },
        {
          path: 'my-badges/:badgeTitle/:issuerAddress',
          element: <BadgeDetailAsUser />
        },
        { path: 'badges/create-badge', element: <CreateBadge /> },
        { path: 'badges/issue-badge/:badgeTitle', element: <IssueBadge /> },
        { path: 'profile', element: <Profile /> }
      ]
    }
  ]);

  return !isInitialized || isLoading ? <PageLoading /> : routes;
}
